import { App } from '../../../App';
import { BasicLayout } from '../../components/BasicLayout';
import { ERROR_2FA_SESSION_EXPIRED } from '../../components/AuthProvider';
import { R } from '../../../config/app';
import { TwoFAFormValues } from '../../../types/ui';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TwoFAForm from './TwoFAForm';
import useAuth from '../../hooks/useAuth';

const LoginScene = () => {
  const trSessionExpired = App.translateContent('sessionExpired');
  const navigate = useNavigate();
  const {
    fetch2faEMAIL,
    secondsLeft2fa,
    fetch2faCode,
    isLoggedIn,
    error2faCode,
    status2faCode,
    verificationId,
    clear2faStates,
    error2faEmail,
  } = useAuth();

  useEffect(() => {
    const isSessionExpiredBecauseEmail =
      error2faEmail && ERROR_2FA_SESSION_EXPIRED.includes(error2faEmail);
    const isSessionExpiredBecauseCode =
      error2faCode && ERROR_2FA_SESSION_EXPIRED.includes(error2faCode);
    if (
      (!verificationId ||
        isSessionExpiredBecauseEmail ||
        isSessionExpiredBecauseCode) &&
      !isLoggedIn
    ) {
      clear2faStates();
      navigate(`${R.login}?errorMessage=${trSessionExpired.title}`);
    }
  }, [verificationId, error2faCode, error2faEmail]);

  const handleSubmit = (values: TwoFAFormValues) => {
    fetch2faCode(values.code.join(''));
  };

  return (
    <BasicLayout onBack={clear2faStates}>
      <TwoFAForm
        isLoggedIn={isLoggedIn}
        onSubmit={handleSubmit}
        resendEMAIL={fetch2faEMAIL}
        secondsLeftToResendSMS={secondsLeft2fa}
        error2faCode={error2faCode}
        status2faCode={status2faCode}
        error2faEmail={error2faEmail}
      />
    </BasicLayout>
  );
};

export default LoginScene;
